import { GridApi } from '@ag-grid-community/core'

/**
 * Where T is the typeof data in the grid and K is the keyof T
 * Example T = Position and K = 'acctId' | 'secId' | 'units' | ...
 *
 * @param columnName
 * @param filter
 */
export async function setFilter<
  T extends unknown,
  K extends Extract<keyof T, string> = Extract<keyof T, string>,
>(
  columnName: K,
  filter: unknown,
  gridApi?: GridApi,
  cacheLoaded = true,
): Promise<void> {
  if (gridApi == null) return

  const filterInstance = gridApi.getFilterInstance?.(columnName)

  if (filterInstance == null) return

  // Ignore values that are the same as the current filter value
  if (filterInstance.getModel?.() == filter) return

  if (filter == null) {
    gridApi.destroyFilter?.(columnName)
  } else {
    await filterInstance.setModel(filter)
  }

  if (cacheLoaded) {
    gridApi.onFilterChanged?.()
  }
}
